import { render, staticRenderFns } from "./SingleTransaction.vue?vue&type=template&id=16213e35&"
import script from "./SingleTransaction.vue?vue&type=script&lang=js&"
export * from "./SingleTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports